import { HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {
    
  getErrorMessage(error: HttpErrorResponse): string {

    console.log(error)
    switch (error.status) {
      case 0: return 'Erro de rede. Verifique sua conexão.';
      case 400: return 'Requisição inválida.';
      case 401: return 'Sessão expirada. Faça login novamente.';
      case 403: return 'Acesso negado.';
      case 404: return 'Recurso não encontrado.';
      case 413: return 'Imagem enviada ultrapassa o limite de 4MB.';
      case 429: return 'Muitas requisições. Tente novamente em breve.';
      case 500: return 'Erro interno do servidor.';
      case 502: return 'Gateway inválido.';
      case 503: return 'Serviço temporariamente indisponível.';
      case 504: return 'Tempo de resposta excedido.';
      default: return error.message || 'Erro inesperado. Tente novamente.';
    }
  }
}